var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".choose-type-section{height:2rem;margin:.5rem;border-radius:.133333rem;border:.026667rem solid #ccc}.choose-type-section.disabled{background:#bcbcbc;color:#222;box-shadow:none}.choose-type-register-logo{background-image:url(" + escape(require("../../../static/img/icon-create-card.png")) + ")}.choose-type-bind-logo,.choose-type-register-logo{background-position:50%;background-repeat:no-repeat;background-size:50%}.choose-type-bind-logo{background-image:url(" + escape(require("../../../static/img/icon-bind-card.png")) + ")}.voucher-choose-type-bottom-tips{margin:.4rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-736234d8","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/voucher/VoucherChooseType.vue
// module id = 468
// module chunks = 0